import { Dialog, Typography, Button, DialogActions, Grid, DialogContent } from "@material-ui/core"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { cerrarComunicacion, limpiarDatosSuspensionEmpresa } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas"
import { AREAS_USUARIOS } from "../../utils/constants"
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import { useState } from "react"


export const CerrarCaso = ({ item }) => {
    const dispatch = useDispatch();
    const { estadoComunicacionActual } = useSelector((state) => state.comunicacionEmpresas);

    const [openCerrarCaso, setOpenCerrarCaso] = useState(false);
    const [mensaje, setMensaje] = useState("")

    const handleSubmit = () => {
        dispatch(cerrarComunicacion(item.cuit, mensaje, estadoComunicacionActual, AREAS_USUARIOS.NACIONAL, () => {
            setOpenCerrarCaso(false)
        }))
    }
    useEffect(() => {
        dispatch(limpiarDatosSuspensionEmpresa());
    }, [dispatch])

    return (
        <>
            <Button variant="contained" color="primary" onClick={() => setOpenCerrarCaso(true)} >Cerrar Caso</Button>
            <Dialog
                fullWidth
                maxWidth={"md"}
                open={openCerrarCaso}
            >
                <Typography variant="h6" style={{ marginTop: '1rem', textAlign: 'center' }}>Cerrar Comunicación</Typography>
                <ValidatorForm onSubmit={handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextValidator
                                    label="Mensaje"
                                    fullWidth
                                    autoComplete="off"
                                    value={mensaje}
                                    onChange={(e) => setMensaje(e.target.value)}
                                    validators={["required"]}
                                    errorMessages={["El mensaje es requerido"]}
                                    multiline
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button type="submit" variant="contained" color="primary">Guardar</Button>
                        <Button autoFocus onClick={() => setOpenCerrarCaso(false)} color="primary">
                            CANCELAR
                        </Button>
                    </DialogActions>
                </ValidatorForm>
            </Dialog>
        </>
    )
}